const ShineShader = {

	name: 'ShineShader',

	uniforms: {

		'tDiffuse': { value: null },
		'exposure': { value: 2.0 },
      'decay': { value: 0.4 },
      'density': { value: 0.25 },
      'weight': { value: 0.51 }

	},
 
	vertexShader: /* glsl */`

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,

	fragmentShader: /* glsl */`

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

        vec2 lightPositionOnScreen;
        
        uniform float exposure;
        uniform float decay;
        uniform float density;
        uniform float weight;
        const int NUM_SAMPLES = 20;

        vec2 uv;

		void main() {
            lightPositionOnScreen = vec2(0.5,0.5);

            vec4 fragCol = texture2D( tDiffuse, vUv );
            vec2 deltaTexCoord = vec2( vUv.xy - lightPositionOnScreen.xy ) / 1.0;
        	vec2 textCoo = vUv.xy;
          	deltaTexCoord *= 1.0 /  float(NUM_SAMPLES) * density;
        	float illuminationDecay = 1.0;

             for(int i=0; i < NUM_SAMPLES ; i++)
          {
                   textCoo -= deltaTexCoord;
                   vec4 zample = texture2D(tDiffuse, textCoo );
  			
                    zample *= illuminationDecay * weight;
  
                   fragCol += zample;
  
                   illuminationDecay *= decay;
           }

			gl_FragColor = fragCol * exposure * vec4(1,1,1, 0.5);


		}`

};
